import styled from 'styled-components';

export const Container = styled.div`
  
`;

export const ContentWapper = styled.div`
  width: 100%;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  padding: 8px;
  margin: 12px 0;
`;

export const GridButtons = styled.div`
  width: 100%;
  display: grid;
  gap: 8px;
  grid-template-columns: 40px 1fr 1fr 1fr;
  grid-template-rows: 56px;
  grid-template-areas:
    'btn-inf space btn-cancel btn-submit';


  @media (max-width: 767.98px) {
    grid-template-columns: 50% 50%;
    grid-template-rows: 56px 56px;
    grid-template-areas:
      'btn-cancel btn-submit'
      'btn-inf space';
  }
`;

export const WrapperBtnInfo = styled.div`
  grid-area: btn-inf;
  padding-top: 16px;
`;

export const WrapperBtnCancel = styled.div`
  grid-area: btn-cancel;
`;

export const WrapperBtnSubmit = styled.div`
  grid-area: btn-submit;
`;

export const Content = styled.div`
  display: flex;
  widht: 100%
  flex-direction: row
  gap: 8px;
  padding: 20px;
`;